import { Fragment, useContext, useState } from "react";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableContext from "context/table/tableContext";

import TableItem from "../TableItem";
import TableMobileHead from "./TableHead";

const TableMobile = () => {
    const { gray100 } = colors;

    const { rows, selectedRows, isTableLoading, idType } =
        useContext(TableContext);

    const [isActiveHead, setIsActiveHead] = useState(selectedRows.length > 0);

    const toggleActiveHead = (value: boolean) => setIsActiveHead(value);

    return (
        <Fragment>
            <TableMobileHead
                isActiveHead={isActiveHead}
                toggleActiveHead={toggleActiveHead}
            />

            <div
                css={css({
                    background: gray100,
                    opacity: isTableLoading ? "0.4" : "1",
                    transition: "opacity 300ms ease-out",

                    "& > div + div": {
                        marginTop: "8px"
                    }
                })}
            >
                {rows.map((row: any, i: number) => (
                    <TableItem
                        key={row[idType]}
                        data={row}
                        isMobileHeadActive={isActiveHead}
                        isFirstItem={i === 0}
                    />
                ))}
            </div>
        </Fragment>
    );
};

export default TableMobile;
